<forge-list [ngClass]="{'forge-menu-expansion--items': isChild}">
  @for (child of nodes; track child) {
    <div role="listitem">
      @if (isLeaf(child)) {
        <metadata-navigation-leaf [id]="child.id" [name]="child.name" [disabled]="child.disabled"
          [selected]="child.selected" [hasError]="child.hasError" (onClick)="select($event)" (onContextMenu)="context($event)">
        </metadata-navigation-leaf>
      }
      @if (!isLeaf(child)) {
        <forge-expansion-panel class="forge-menu-expansion" [attr.open]="isExpanded(child)">
          <forge-list-item slot="header" [dense]="compactMode" role="">
            <button type="button" [ngClass]="{'compact-expansion-panel': compactMode}">
              {{child.name}}
            </button>
            <forge-open-icon slot="end"></forge-open-icon>
          </forge-list-item>
          <metadata-navigation-tree [nodes]="child.nodes" isChild="true" (onClick)="select($event)" (onContextMenu)="context($event)">
        </metadata-navigation-tree>
      </forge-expansion-panel>
    }
  </div>
}
</forge-list>
